<template>

    <div class="ui segment">
        <h4 class="ui dividing header">Impostos</h4>
        <span v-if="!tax_ok">
          {{texto_ret}}
        </span>
        <div v-if="tax_ok" class="ui accordion">
          <div class="title">
            <div> 
                <table class="ui small table">
                  <thead>
                    <tr>
                      <th>Filial:{{billing_branch}}</th>
                      <th>Nota:{{$formatCurrency(total_tax)}}</th>
                      <th>Imp:{{$formatCurrency(total_tax - total_merch) }}</th>
                    </tr>
                  </thead>
                </table>
            </div>
          </div>
          <div class="content">
          <table class="ui small table">
            <thead>
              <tr>
                <th>Imposto</th>
                <th>Base</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tax, idx) in resume_tax" :key="idx">
                <td>{{tax[1]}}</td>
                <td>{{$formatCurrency(tax[2])}}</td>
                <td>{{$formatCurrency(tax[3])}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>        
</template>

<script>
  export default {
    props: ["quotation"],
    data() {
      return {
        resume_tax: [],
        billing_branch: '',
        total_merch: 0,
        total_tax: 0,
        tax_ok: false,
        texto_ret: ''
      }
    },
    created() {
      if (this.quotation.aTaxinfo != null) {
        this.tax_ok = this.quotation.aTaxinfo[0]
        if ( this.tax_ok ) {
          this.billing_branch      = this.quotation.aTaxinfo[2][3]
          this.total_merch         = this.quotation.aTaxinfo[2][1]
          this.total_tax           = this.quotation.aTaxinfo[2][2]
          this.resume_tax          = this.quotation.aTaxinfo[2][0]
        } else {
          this.texto_ret = this.quotation.aTaxinfo[1] 
        }
      }
    },
     mounted() {
      $(".accordion").accordion()
    },
    methods: {
      isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    }  
  }
</script>

